import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MdSupportAgent } from 'react-icons/md';
import ContactForm from '../ContactForm';

class CallToActonV1 extends Component {

  state = {
    showModal: false
  };

  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { showModal } = this.state;

    return (
      <>
        <div className="ltn__call-to-action-area call-to-action-6 before-bg-bottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                  
                  <div className="coll-to-info text-color-white">
                    <h1>Looking for a dream home?</h1>
                    <p>We can help you realize your dream of a new home</p>
                  </div>

                  <div className="btn-wrapper go-top d-flex align-items-center mx-0">
                    <Link
                      className="btn btn-effect-3 btn-white"
                      to="/project"
                    >
                      Explore Properties <i className="icon-next" />
                    </Link>

                    <button
                      type="button"
                      className="btn btn-effect-3 btn-white d-flex align-items-center justify-content-center p-2 mx-2"
                      style={{ width: "60px", height: "60px" }}
                      onClick={this.openModal}
                    >
                      <MdSupportAgent size={40} />
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

 
        {showModal && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title mx-5 mt-4">Contact Form</h5>
                  <button
                    type="button"
                    className="btn-close mx-3"
                    onClick={this.closeModal}
                  />
                </div>
                <div className='modal-body'>
                    <ContactForm />
                </div>
              </div>
            </div>
            <div
              onClick={this.closeModal}
            />
          </div>
        )}
      </>
    );
  }
}

export default CallToActonV1;
